// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/crfi-runway-friction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/crfi-runway-friction/crfi-runway-friction.js';

mount([g0]);
